import SESSION_RECORDING_EVENTS from "utils/session-recording-events"

// Session-recording events that should start a Sentry Replay recording.
const TRIGGER_EVENTS = [SESSION_RECORDING_EVENTS.subPopupOpened]

// Rendered by layouts/web/_sentry_js.html.slim from the
// sentry_js_replays_paywall_rate feature flag; absent = never trigger.
const RATE_META_NAME = "sentry-replay-paywall-rate"

let decided = false
let furthestTaggedStep = -1
const pendingEvents = []
let onLoadRegistered = false

function paywallRate() {
  const meta = document.querySelector(`meta[name="${RATE_META_NAME}"]`)
  const rate = meta ? parseFloat(meta.content) : NaN
  return Number.isFinite(rate) ? rate : 0
}

function sdkReady(sentry) {
  return (
    sentry && (typeof sentry.getClient === "function" || typeof sentry.getReplay === "function")
  )
}

function recordWithLoadedSdk(sentry, eventName, funnelStep) {
  if (typeof sentry.addBreadcrumb === "function") {
    sentry.addBreadcrumb({ category: "session-recording", message: eventName, level: "info" })
  }

  // Structured log per event: the Logs explorer can chart counts grouped by
  // the event attribute across all sessions, recorded or not.
  if (sentry.logger && typeof sentry.logger.info === "function") {
    const attributes = { event: eventName }
    if (funnelStep >= 0) attributes.funnel_step = funnelStep
    sentry.logger.info("session_recording", attributes)
  }

  if (funnelStep > furthestTaggedStep && typeof sentry.setTag === "function") {
    furthestTaggedStep = funnelStep
    sentry.setTag("paywall", eventName)
  }

  if (decided || !TRIGGER_EVENTS.includes(eventName)) return

  const replay = typeof sentry.getReplay === "function" ? sentry.getReplay() : null
  if (!replay) return

  decided = true
  if (Math.random() >= paywallRate()) return

  Promise.resolve(replay.flush()).catch(() => {})
}

function drainPendingEvents() {
  const sentry = window.Sentry
  if (!sdkReady(sentry)) return

  pendingEvents.splice(0).forEach(([eventName, funnelStep]) => {
    recordWithLoadedSdk(sentry, eventName, funnelStep)
  })
}

// Mirrors the Hotjar/Clarity sinks for Sentry: every event becomes a
// breadcrumb (visible on the replay timeline), funnel steps keep the
// session's paywall tag at the furthest step reached (so the Replays list
// can be segmented per step), and a paywall opening flushes the replay.
// Replay.flush() uploads the rolling buffer (up to ~60s of pre-paywall
// context) and keeps recording for the rest of the session, also for
// sessions that were not sampled into recording; on an already recording
// session it is a plain flush of the same replay. One sampling decision per
// page.
export default function recordSessionEventInSentry(eventName, funnelStep = -1) {
  const sentry = window.Sentry

  if (sdkReady(sentry)) {
    recordWithLoadedSdk(sentry, eventName, funnelStep)
    return
  }

  if (!sentry || typeof sentry.onLoad !== "function") return

  pendingEvents.push([eventName, funnelStep])
  if (onLoadRegistered) return

  onLoadRegistered = true
  sentry.onLoad(drainPendingEvents)
}
